var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Youtube",
    clipPath: "url(#clip0_57_2160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.543945 34.8467C0.543945 16.069 15.7663 0.84668 34.5439 0.84668C53.3217 0.84668 68.5439 16.069 68.5439 34.8467C68.5439 53.6245 53.3217 68.8467 34.5439 68.8467C15.7663 68.8467 0.543945 53.6245 0.543945 34.8467Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M51.9196 26.4503C51.5025 24.8481 50.2736 23.5862 48.7132 23.1581C45.8853 22.3799 34.5441 22.3799 34.5441 22.3799C34.5441 22.3799 23.2032 22.3799 20.3751 23.1581C18.8146 23.5862 17.5856 24.8481 17.1686 26.4503C16.4109 29.3541 16.4109 35.4131 16.4109 35.4131C16.4109 35.4131 16.4109 41.4719 17.1686 44.3762C17.5856 45.9784 18.8146 47.24 20.3751 47.6684C23.2032 48.4466 34.5441 48.4466 34.5441 48.4466C34.5441 48.4466 45.8853 48.4466 48.7132 47.6684C50.2736 47.24 51.5025 45.9784 51.9196 44.3762C52.6776 41.4719 52.6776 35.4131 52.6776 35.4131C52.6776 35.4131 52.6776 29.3541 51.9196 26.4503Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.1448 41.6467V30.3135L40.2115 35.9804L31.1448 41.6467Z",
    fill: "#DC6200"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_2160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white",
    transform: "translate(0.543945 0.84668)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.60116cb6d1c94de1194f5aa0e421e76f.svg";
export { ForwardRef as ReactComponent };